import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LiquidacaoModalDetalhesComponent } from './liquidacao-modal-detalhes.component';
import { AbstractComponent } from '../util/abstract.component';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { SessaoService } from '../services/sessao.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Contrato } from '../modelo/contrato';
import { Boleto } from '../modelo/boleto';
import { Parcela } from '../modelo/parcela';
import { Config } from '../services/config';

declare var $: any;

@Component({
  selector: 'app-liquidacao-contrato',
  templateUrl: './liquidacao-contrato.component.html',
  styleUrls: ['./liquidacao.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class LiquidacaoContratoComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;
  boleto: Boleto;
  lstMensagem: string[];

  constructor(
    private spinnerService: Ng4LoadingSpinnerService,
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,
    private mensagemService: MensagemService,
    private router: Router,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);
    this.contrato = JSON.parse(sessionStorage.getItem('liquidacaoContrato'));
    this.lstMensagem = this.contrato.lstMensagem;

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  modalDetalhar(): void {
    this.dialog.open(LiquidacaoModalDetalhesComponent, {
      width: Config.POPUP_100VW,
      height: Config.POPUP_100FULL,
      data: {
        contrato: this.contrato
      }
    });
  }

  onClickConfirmar(): void {
    this.liquidacaoAntecipadaService.efetivarLiquidacaoContrato(this.contrato).subscribe(
      (result: Boleto) => {
        if (result.cdMsgemRetorno == "0") {
          this.boleto = result;
          sessionStorage.setItem('liquidacaoBoleto', JSON.stringify(this.boleto));
          this.router.navigate(['/BF-Portal/liquidacaoContratoConclusao']);
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-liquidacao-cli/liquidacao-contrato.component.ts